export default __webpack_public_path__ + "static/media/blog-img85.9ad8ee41.jpg";